import type { WidgetInterface } from '../types';
import WidgetListItem from './WidgetListItem';

interface WidgetsListProps {
  widgets: WidgetInterface[];
  accountId: number;
}

const WidgetsList = ({ widgets, accountId }: WidgetsListProps) => {
  return (
    <>
      {widgets?.map((wdg: WidgetInterface) => (
        <WidgetListItem key={wdg.id} widget={wdg} accountId={accountId} />
      ))}
    </>
  );
};

export default WidgetsList;
